import React, { useState } from 'react';
import CourseBlockRenderer from './CourseBlockRenderer';

export default function MarkdownEditor({ label, value = '', onChange, rows = 6, placeholder = '' }) {
    const [preview, setPreview] = useState(false);

    return (
        <div>
            {label && (
                <div className="flex items-center justify-between mb-1">
                    <label className="text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wide">{label}</label>
                    <div className="flex rounded-lg overflow-hidden border border-gray-200 dark:border-white/10 text-xs">
                        <button
                            type="button"
                            onClick={() => setPreview(false)}
                            className={`px-2 py-0.5 transition-colors ${!preview ? 'bg-cyan-500 text-white' : 'bg-white dark:bg-gray-800 text-gray-500 hover:text-gray-700 dark:hover:text-gray-300'}`}
                        >Éditer</button>
                        <button
                            type="button"
                            onClick={() => setPreview(true)}
                            className={`px-2 py-0.5 transition-colors ${preview ? 'bg-cyan-500 text-white' : 'bg-white dark:bg-gray-800 text-gray-500 hover:text-gray-700 dark:hover:text-gray-300'}`}
                        >Aperçu</button>
                    </div>
                </div>
            )}
            {preview ? (
                <div className="min-h-[80px] p-3 rounded-lg border border-gray-200 dark:border-white/10 bg-gray-50 dark:bg-gray-800/50 text-sm">
                    <CourseBlockRenderer content={value} />
                </div>
            ) : (
                <textarea
                    value={value}
                    onChange={e => onChange(e.target.value)}
                    rows={rows}
                    placeholder={placeholder}
                    className="w-full px-3 py-2 rounded-lg border border-gray-200 dark:border-white/10 bg-white dark:bg-gray-800 text-sm text-gray-800 dark:text-gray-200 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-cyan-500 font-mono resize-y"
                />
            )}
        </div>
    );
}
